// api/adminProduct.js
import { API_BASE_URL, ADMIN_SECRET } from '../utils/constants';

/**
 * Update local-only fields for a product + optionally attach images.
 * - If no files/urls provided -> sends JSON (no Content-Type issues)
 * - If files/urls provided -> sends FormData (multer-friendly)
 *
 * @param {number|string} id
 * @param {{subname?:string,description?:string,sponsored?:boolean,is_active?:boolean}} fields
 * @param {{
 *   files?: File[],                // optional uploaded files
 *   imageUrls?: string[],          // optional external image urls
 *   replaceImages?: boolean,       // if true -> replace old images
 *   appendImages?: boolean         // if true -> append (default when any files/urls)
 * }} imagesOptions
 */
 export async function updateProductLocal(id, fields, imagesOptions) {

   // If we have files -> send multipart/form-data
   if (imagesOptions?.files?.length) {
     const fd = new FormData();
     // strict fields
     if (typeof fields.subname !== 'undefined') fd.append('subname', fields.subname);
     if (typeof fields.description !== 'undefined') fd.append('description', fields.description);
     if (typeof fields.sponsored !== 'undefined') fd.append('sponsored', String(!!fields.sponsored));
     if (typeof fields.is_active !== 'undefined') fd.append('is_active', String(!!fields.is_active));

    (imagesOptions.imageUrls || []).forEach((u) => fd.append('imageUrls[]', u));
    if (typeof imagesOptions.replaceImages !== 'undefined') fd.append('replaceImages', String(!!imagesOptions.replaceImages));
    if (typeof imagesOptions.appendImages !== 'undefined') fd.append('appendImages', String(!!imagesOptions.appendImages));

     for (const f of imagesOptions.files) fd.append('images', f);

     const res = await fetch(`${API_BASE_URL}/api/products/${id}`, {
       method: 'PUT',
       credentials: 'include',
       headers: { 'admin-secret': `${ADMIN_SECRET}` },
       body: fd,
     });
     if (!res.ok) {
       let msg = '';
       try { msg = await res.text(); } catch {}
       throw new Error(`Update failed: ${res.status} ${res.statusText} — ${msg}`);
     }
     return res.json();
   }

   // else JSON-only update
   const res = await fetch(`${API_BASE_URL}/api/products/${id}`, {
     method: 'PUT',
     credentials: 'include',
     headers: {
       'Content-Type': 'application/json',
       'admin-secret': `${ADMIN_SECRET}`,
     },
     body: JSON.stringify({
       subname: fields.subname ?? '',
       description: fields.description ?? '',
       sponsored: !!fields.sponsored,
       is_active: !!fields.is_active,
     }),
   });
   if (!res.ok) {
     let msg = '';
     try { msg = await res.text(); } catch {}
     throw new Error(`Update failed: ${res.status} ${res.statusText} — ${msg}`);
   }
   return res.json();
 }


export async function deleteProductImage(productId, imageId) {
  const res = await fetch(`${API_BASE_URL}/api/products/${productId}/images/${imageId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { 'admin-secret': `${ADMIN_SECRET}` }, // swap for real auth
  });
  if (!res.ok) throw new Error(await res.text() || 'Failed to delete image');
  return true;
}
